// Material UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    paper: {
      padding: '32px 32px 8px',
      margin: '16px 8px',
    },
    sectionTitle: {
      marginBottom: theme.spacing(2),
    },
    autocomplete: {
      marginBottom: theme.spacing(2),
    },
    selectedCustomerContainer: {
      marginTop: theme.spacing(2),
    },
    customerChip: {
      margin: theme.spacing(0.5),
    },
    addButton: {
      marginTop: theme.spacing(2),
    },
    newUserButton: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
    },
    modalContent: {
      minWidth: 500,
      padding: theme.spacing(2),
    },
    buttonContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
    }
  })
);

export default useStyles;